import authReducer from '@/shared/auth/auth.reducer';
import userReducer from './user.reducer';
import caseReducer from './case.reducer';
import callCenterAgentReducer from './callCenterAgent.reducer';
import roleReducer from './role.reducer';
import permissionReducer from './permission.reducer';
import departmentReducer from './department.reducer';
import agentProductivityReportReducer from './agentProductivity.reducer';
import sessionReportReducer from './sessionReport.reducer';
import breakReportReducer from './breakReport.reducer';
import auditLogReducer from './auditLog.reducer';
import agentStatisticsReducer from './agent-statistics.reducer';
import branchReducer from './branch.reducer';
import provinceReducer from './province.reducer';
import districtReducer from './district.reducer';
import villageReducer from './village.reducer';
import caseCategoryReducer from './caseCategory.reducer';
import caseAssignmentPageReducer from './caseAssignment.reducer';
import followUpCasesReducer from './followUpCases.reducer';
import caseTransferPageReducer from './caseTransfer.reducer';
import caseReportReducer from './caseReport.reducer';
import { casesPanelReducer, agentPanelReducer } from './casePanel.reducer';
import dashboardReducer from './dashboard.reducer';
import voicemailReducer from './voicemail.reducer';
import campaignReducer from './campaign.reducer';
import campaignDashboardReducer from './campaign-dashboard.reducer';
import incomingCallsReducer from './incoming-calls.reducer';
import outgoingCallsReducer from './outgoing-calls.reducer';
import queueStatusReducer from './queue-status.reducer';
import realtimeReducer from './realtime.reducer';
import qstatDashboardReducer from './qstat-dashboard.reducer';
import wallboardReducer from './wallboard.reducer';
import kpiDashboardReducer from './kpi-dashboard.reducer';
import referenceDataReducer from './reference-data.reducer';
import userActivationReducer from './user-activation.reducer';
import chatRoomReducer from './chat-room.reducer';
const rootReducer = {
    auth: authReducer,
    user: userReducer,
    case: caseReducer,
    callCenterAgent: callCenterAgentReducer,
    role: roleReducer,
    permission: permissionReducer,
    department: departmentReducer,
    agentProductivityReport: agentProductivityReportReducer,
    sessionReport: sessionReportReducer,
    breakReport: breakReportReducer,
    auditLog: auditLogReducer,
    agentStatistics: agentStatisticsReducer,
    branch: branchReducer,
    province: provinceReducer,
    district: districtReducer,
    village: villageReducer,
    caseCategory: caseCategoryReducer,
    caseAssignmentPage: caseAssignmentPageReducer,
    followUpCases: followUpCasesReducer,
    caseTransferPage: caseTransferPageReducer,
    caseReport: caseReportReducer,
    casesPanel: casesPanelReducer,
    campaign: campaignReducer,
    campaignDashboard: campaignDashboardReducer,
    agentPanel: agentPanelReducer,
    dashboard: dashboardReducer,
    voicemail: voicemailReducer,
    incomingCalls: incomingCallsReducer,
    outgoingCalls: outgoingCallsReducer,
    queueStatus: queueStatusReducer,
    realtime: realtimeReducer,
    qstatDashboard: qstatDashboardReducer,
    wallboard: wallboardReducer,
    kpiDashboard: kpiDashboardReducer,
    referenceData: referenceDataReducer,
    userActivation: userActivationReducer,
    chatRoom: chatRoomReducer,
};
export default rootReducer;
